export default __webpack_public_path__ + "images/17_thumbnail.jpg";